import React, { FC } from 'react'
import Routes from './routes'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { IntlProvider } from 'react-intl'
import { companyMessage } from './assets/i18n/i18n'

const queryClient = new QueryClient()

const App: FC = () => {
  return (
    <IntlProvider locale='en' messages={companyMessage}>
      <QueryClientProvider client={queryClient}>
        <Routes />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </IntlProvider>

  )
}

export default App
